import React from "react";
import { useHits, useInstantSearch } from "react-instantsearch";

export default function PhotoGrid() {
  const { hits } = useHits();
  const { setIndexUiState } = useInstantSearch();

  // Aplatir tous les sous-documents (docs[]) de tous les hits
  const photos = [];
  for (const hit of hits) {
    const parentUrl = hit.urlplus || "#";
    const parentCote = hit.cote || "";
    const parentDossier = hit.dossier || "";
    const docs = hit.docs || [];
    for (const doc of docs) {
      const cote = doc.cote || "";
      if (!cote) continue;
      const imgUrl = `${parentDossier}${cote}.jpg?t=500`;
      photos.push({ imgUrl, parentUrl, parentCote });
    }
  }

  const handleClick = (e, parentUrl, cote) => {
    if (!cote) return;
    e.preventDefault();
    e.stopPropagation();
    setIndexUiState((prev) => ({ ...prev, query: cote }));
  };

  return (
    <>
      {photos.length === 0 && (
        <div style={{ textAlign: "center", padding: "24px", color: "#999" }}>
          Aucune photo trouvée
        </div>
      )}
      {photos.map(({ imgUrl, parentUrl, parentCote }, i) => (
        <div key={`${parentCote}_${i}`} className="sui-result sui-result--photo">
          <a href={parentUrl} target="_blank" rel="noopener noreferrer">
            <img
              src={imgUrl}
              alt=""
              loading="lazy"
              onError={(e) => { e.target.style.display = "none"; }}
            />
          </a>
          <div
            onClick={(e) => handleClick(e, parentUrl, parentCote)}
            title={"Rechercher " + parentCote}
            style={{
              fontSize: "0.65rem",
              color: "#888",
              marginTop: "3px",
              textAlign: "center",
              cursor: "pointer",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {parentCote}
          </div>
        </div>
      ))}
    </>
  );
}
